<template>
	<footer class="c-footer" v-if="footer">
		<vue-cookie-accept-decline
			:ref="'cookiePanel'"
			:elementId="'cookiePanel'"
			:debug="false"
			:position="'bottom-left'"
			:type="'floating'"
			:disableDecline="true"
			:transitionName="'slideFromBottom'"
			:showPostponeButton="false"
			@status="cookieStatus"
			@clicked-accept="cookieClickedAccept"
			@clicked-decline="cookieClickedDecline">

			<!-- Optional -->
			<!-- <div slot="postponeContent">
					&times;
			</div> -->

			<!-- Optional -->
			<div slot="message" v-html="cookieMessage">
			</div>

			<!-- Optional -->
			<!-- <div slot="declineContent">
				{{ cookieButtonNo }}
			</div> -->

			<!-- Optional -->
			<div slot="acceptContent">
					{{ cookieButtonYes }}
			</div>
		</vue-cookie-accept-decline>
		<div class="c-footer__branding">
			<img src="/static/images/glasses.svg" alt="Bandara">
		</div>
		<div class="container">
			<h4 @click="scrollToTop(300)">{{ footer.title }}</h4>
			<div class="c-footer__content" v-html="footer.content"></div>
			<div class="c-footer__icons">
				<a class="c-footer__icon"
					v-bind:class="'c-footer__icon--' + icon.type.toLowerCase()"
					v-for="icon in footer.icons"
					:href="icon.link"
					target="_blank" rel="noopener">
						<span class="visuallyhidden">{{ icon.type }}</span>
				</a>
			</div>
		</div>
	</footer>
</template>

<script>
import { bootstrap } from 'vue-gtag'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import CNewsletterSignup from '@/components/NewsletterSignup';

export default {
	name: 'footer',
	data: () => ({
		footerData: {}
	}),
	components: {
		VueCookieAcceptDecline,
		CNewsletterSignup
	},
	computed: {
		settings() {
			return this.$store.state.general.settings;
		},
		footer() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].footer
		},
		cookieMessage() {
			return this.settings.currentLang === 'en-us' ? 'We use cookies to best tailor the content and website to the needs of visitors and to analyze traffic. For more information, in particular how you can prevent cookies from being set by setting your browser, please see our <a href="/en/privacy-policy">Privacy Policy</a>.' : 'Wir verwenden Cookies, um den Inhalt und die Webseite bestmöglich auf die Bedürfnisse der Besucher abzustimmen und um den Datenverkehr zu analysieren. Weitere Informationen, insbesondere wie Sie durch die Einstellung Ihres Browsers das Setzen von Cookies verhindern können, finden Sie in unserer <a href="/privacy_policy">Datenschutzerklärung</a>.'
		},
		// cookieButtonNo() {
		// 	return this.settings.currentLang === 'en-us' ? 'Opt out' : 'Lieber nicht'
		// },
		cookieButtonYes() {
			return this.settings.currentLang === 'en-us' ? 'Close' : 'Schliessen'
		},
	},
	methods: {
		cookieStatus(e) {
			// console.log('cookieStatus', e)
			if (e === 'decline') {
				// console.log('cookieStatus declined')
				// this.$gtag.optOut()
			}
			if (e === 'accept') {
				// console.log('cookieStatus accepted')
				this.bootstrapGtag()
				// this.$gtag.optIn()
			}
		},
		cookieClickedAccept(e) {
			// console.log('cookieClickedAccept', e)
			this.bootstrapGtag()
			// this.$gtag.optIn()
		},
		cookieClickedDecline(e) {
			// console.log('cookieClickedDecline', e)
			// this.$gtag.optOut()
		},
		scrollToTop(scrollDuration) {
			var scrollStep = -window.scrollY / (scrollDuration / 15),
			scrollInterval = setInterval(function(){
				if ( window.scrollY != 0 ) {
					window.scrollBy( 0, scrollStep )
				}
					else clearInterval(scrollInterval)
			}, 15)
		},
		bootstrapGtag() {
			bootstrap().then((gtag) => {
				// console.log('bootstrapped', gtag)
			})
		}
	}
};
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	.c-footer {
		width: 100%;
		background-color: $colorWhite;
		color: $colorDark;
		text-align: center;
		padding: 0;
		padding-bottom: 2rem;
		position: relative;
		z-index: 1;

		@include mq($from: medium) {
			padding-bottom: 4rem;
		}

		a {
			color: $colorGray;
			text-decoration: none;

			&:hover {
				color: $colorDark;
			}
		}
		h4 {
			color: $colorBrandMain;
			font-size: 2rem;
			font-weight: 600;
			margin-bottom: .5rem;
			cursor: pointer;

			@include mq($from: medium) {
				font-size: 3rem;
			}
		}

		&__branding {
			background-color: $colorBrandMain;
			padding: .75rem 0;
			margin-bottom: 1rem;

			img {
				display: block;
				margin: 0 auto;
				width: 1.5rem;
				height: auto;
			}

			@include mq($from: medium) {
				margin-bottom: 2rem;
				padding: 1rem 0;

				img {
					width: 2rem;
				}
			}
		}

		&__content {
			font-family: $fontFamilySerif;
		}

		&__icons {
			display: flex;
			justify-content: center;
			margin-top: 2rem;
			width: 100%;
		}
		&__icon {
			display: block;
			width: 30px;
			height: 30px;
			background-size: 100%;
			background-repeat: no-repeat;
			margin: 0 .75rem;

			&--facebook { background-image: url('../assets/images/icon-fb.png'); }
			&--twitter { background-image: url('../assets/images/icon-twitter.png'); }
			&--linkedin { background-image: url('../assets/images/icon-linkedin.png'); }
			&--youtube { background-image: url('../assets/images/icon-instagram.png'); }

			&:hover {
				opacity: .8;
			}
		}
	}

	#cookiePanel,
	.cookie__floating__buttons,
	.cookie__floating__buttons__button {
		color: $colorText !important;
		font-family: $fontFamilyBase !important;
		transition: background-color 0.3s ease-in-out;
	}

	.cookie__floating__content.cookie__floating__content {
		max-height: 420px;
		font-size: 16px;
	}

	.cookie__floating__buttons__button--decline {
		color: $colorHighlight !important;
		background-color: $colorBgGray !important;

		&:hover {
			color: $colorWhite !important;
			background-color: $colorHighlight !important;
		}
	}

	.cookie__floating__buttons__button--accept {
		color: $colorBrandMain !important;
		background-color: $colorBgGray !important;

		&:hover {
			color: $colorWhite !important;
			background-color: $colorBrandMain !important;
		}
	}

</style>



// WEBPACK FOOTER //
// Footer.vue?6413c0a1